import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface GetAggregatedResponsesInput {
  questionId: number;
}

export interface AggregatedResponsesResult {
  aggregatedResponses: {
    questionId: number;
    total: number;
    options: Array<{
      option: string;
      count: number;
    }>;
  };
}

const getAggregatedResponsesQuery = gql`
  query aggregatedResponses($questionId: Int!) {
    aggregatedResponses(questionId: $questionId) {
      questionId
      total
      options {
        option
        count
      }
    }
  }
`;

export const getAggregatedResponses = (
  input: GetAggregatedResponsesInput
): Promise<AggregatedResponsesResult> => {
  return gqlClient.request<AggregatedResponsesResult>(getAggregatedResponsesQuery, input);
};
